<template>
  <x-btn
    class="editor-menubar-button"
    color="tertiary"
    icon
    round
    :class="{ 'is-active': isActive }"
    @click="command"
  >
    <slot />
  </x-btn>
</template>

<script>
  export default {
    name: 'TextEditorButton',
    props: {
      command: {
        type: Function,
        required: true
      },
      isActive: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
.x-btn {
    background: rgba(255, 255, 255, 0.25) !important;
    border: none !important;
}
</style>
